export default __webpack_public_path__ + "static/media/doctors-cuate.31ca63fe.svg";